<ng-container *transloco="let t">
    <div class="confirm-email-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div
                    class="altair-form ml-auto mr-auto border-radius bg-white"
                    [class.card-borderd-theme]="themeService.isCardBorder()"
                    [class.component-dark-theme]="themeService.isDark()"
                >
                    <div class="title text-center">
                        <h3>
                            {{t('welcome')}} ALTAIR
                        </h3>
                        <p class="ml-auto mr-auto">
                            {{t('your-mail-is-verified')}}
                        </p>
                    </div>
                    <div class="admin text-center">
                        <div class="logo position-relative text-success rounded-circle">
                            <i class="material-symbols-outlined">
                                done
                            </i>
                        </div>
                        <span class="d-block fw-medium">
                            {{t('your-mail-verified')}} <span class="text-success">{{t('successfully')}}</span>
                        </span>
                    </div>
                    <a routerLink="/authentication/sign-in" mat-button class="btn">
                        {{t('back-to-home')}}
                    </a>
                </div>
            </div>
        </div>
    </div>
</ng-container>
